import { createReduxActionTypes } from '../../../utils/actionFactory';
import Optional from '../../../utils/optional';

const OPEN_ORDER_SIMCARD_WIZARD = 'OPEN_ORDER_SIMCARD_WIZARD';
const RESET_ORDER_SIMCARD_WIZARD = 'RESET_ORDER_SIMCARD_WIZARD';
const SET_SIMCARD_DATA = 'SET_SIMCARD_DATA';
const SET_ADDRESSES_OPTIONS = 'SET_ADDRESSES_OPTIONS';
const SET_ACCOUNTS_OPTIONS = 'SET_ACCOUNTS_OPTIONS';
const SET_PROVIDERS_OPTIONS = 'SET_PROVIDERS_OPTIONS';

export const actionTypes = createReduxActionTypes(
  'REQUEST_ORDER_SIMCARD_WIZARD',
  [
    OPEN_ORDER_SIMCARD_WIZARD,
    SET_SIMCARD_DATA,
    SET_ADDRESSES_OPTIONS,
    SET_ACCOUNTS_OPTIONS,
    RESET_ORDER_SIMCARD_WIZARD,
    SET_PROVIDERS_OPTIONS
  ]
);

const DEFAULT_STATE = {
  open: false,
  simcardData: {
    firstStep: {
      provider: null,
      count: 0,
      account: null
    },
    secondStep: {
      shipping_address: '',
      name: '',
      att: '',
      additionalValues: null
    }
  },
  addressesOptions: [],
  accountsOptions: [],
  providersOptions: [],
  iot: false
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[OPEN_ORDER_SIMCARD_WIZARD]: {
      const { iot } = action;
      return {
        ...state,
        open: true,
        iot: Optional(iot).or(false)
      };
    }
    case actionTypes[SET_SIMCARD_DATA]: {
      const { simcardData, step } = action;
      return {
        ...state,
        simcardData: {
          ...state.simcardData,
          [step]: { ...state.simcardData[step], ...simcardData }
        }
      };
    }
    case actionTypes[SET_ADDRESSES_OPTIONS]: {
      return {
        ...state,
        addressesOptions: [...action.addressesOptions]
      };
    }
    case actionTypes[SET_ACCOUNTS_OPTIONS]: {
      const { accountsOptions } = action;
      return {
        ...state,
        accountsOptions
      };
    }
    case actionTypes[SET_PROVIDERS_OPTIONS]: {
      const { providersOptions } = action;
      return {
        ...state,
        providersOptions
      };
    }
    case actionTypes[RESET_ORDER_SIMCARD_WIZARD]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  openOrderSimcard: iot => ({
    type: actionTypes[OPEN_ORDER_SIMCARD_WIZARD],
    iot
  }),
  setSimcardData: (simcardData, step) => ({
    type: actionTypes[SET_SIMCARD_DATA],
    simcardData,
    step
  }),
  setAddressesOptions: addressesOptions => ({
    type: actionTypes[SET_ADDRESSES_OPTIONS],
    addressesOptions
  }),
  setAccountOptions: accountsOptions => ({
    type: actionTypes[SET_ACCOUNTS_OPTIONS],
    accountsOptions
  }),
  setProvidersOptions: providersOptions => ({
    type: actionTypes[SET_PROVIDERS_OPTIONS],
    providersOptions
  }),
  resetOrderSimcard: () => ({ type: actionTypes[RESET_ORDER_SIMCARD_WIZARD] })
};
